import React, { useEffect, useState } from "react"
import { editModeOn, firstLetterCapital, getFromDecreaptLocalStorage } from "../utilFunctions";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { toast } from "react-toastify";
import { REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import { axiosRequest } from "../service";
import { functionalities, modes } from "../consts";

const CreateRole = (props) => {

  const [createRolePayload, setCreateRolePayload] = useState({})
  const { setOpenDropDown } = props
  const defaultData = {
    roleName: "",
    roleDescription: "",
    status: 3,
    createdBy: 1,
    createdDate: "",
    modifiedBy: 1,
    modifiedDate: "",
    roleFunctionalities: props.functionalityList.map(list => {
      return {
        functionId: list.functionalityID,
        functionalityName: list.functionalityName,
        viewMode: 0,
        editMode: 0,
        deleteMode: 0
      }
    })
  }
  const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList")


  useEffect(() => {
    setCreateRolePayload(defaultData)
  }, [props.functionalityList])

  const updateFunctionality = (id, value, key) => {
    const updatedFunctionality = {}
    // if user check edit mode, auto check the view mode also and disable the view mode to prevent uncheck
    if (key === modes.EDIT_MODE && value === 1) { // iif user checks edit mode
      updatedFunctionality[modes.VIEW_MODE] = 1 // check view mode also
    }
    updatedFunctionality[key] = value;
    setCreateRolePayload({ ...createRolePayload, roleFunctionalities: createRolePayload.roleFunctionalities.map(l => l.functionId == id ? { ...l, ...updatedFunctionality } : l) });
  };

  const saveRoleData = () => {
    if (!createRolePayload.roleName) {
      toast.error("Please Enter Role Name")
      return
    }
    if (!createRolePayload.roleDescription) {
      toast.error("Please Enter Role Description")
      return
    }
    if (createRolePayload.status == 3) {
      toast.error("Please Select CMS Status")
      return
    }
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/role`, createRolePayload).then(data => {
      toast.success("Role Created Successfully")
      props.getRolesdata()
      props.getFunctionalityListdata()
      setCreateRolePayload({})
      props.navigateToRoleMater()
    }).catch(error => {
      console.log(error)
      toast.error("Something Went Wrong!")
    })
  }
  const roleNameCreateHandler = (value) => {
    if (value.length > 30) {
      // toast.error("Role Name can't be more than 30 characters.")
      return
    }
    setCreateRolePayload({ ...createRolePayload, roleName: value })
  }
  const roleDescriptionCreateHandler = (value) => {
    if (value.length > 150) {
      // toast.error("Role Description can't be more than 150 characters.")
      return
    }
    setCreateRolePayload({ ...createRolePayload, roleDescription: value })
  }

  return (
    <section className="p-4">
      <h5>Role Details</h5>
      <div className="p-4 px-1">
        <div className="d-flex justify-content-between w-75">
          <div className="me-3">
            <small className="text-secondary">Role Name</small><span className="text-danger ms-1">*</span>
            <input
              type="text"
              className="form-control bg-gray mt-2"
              placeholder="Role Name"
              value={createRolePayload.roleName}
              onChange={(e) => roleNameCreateHandler(e.target.value)} />
          </div>
          <div className="me-3">
            <small className="text-secondary">Role Description</small><span className="text-danger ms-1">*</span>
            <input
              type="text"
              className="form-control bg-gray mt-2"
              placeholder="Role Description"
              value={createRolePayload.roleDescription}
              onChange={(e) => roleDescriptionCreateHandler(e.target.value)} />
          </div>
          <div className="me-3">
            <small className="text-secondary">Role Status</small><span className="text-danger ms-1">*</span>
            <Select
              styles={{
                control: (provided) => ({
                  ...provided,
                  cursor: 'pointer',
                }),
                option: (provided) => ({
                  ...provided,
                  cursor: 'pointer',
                }),
              }}
              options={cmsStatusListCookies.map(list => {
                return { label: firstLetterCapital(list.name), value: list.id }
              })}
              onChange={(data) => setCreateRolePayload({ ...createRolePayload, status: data.value })}
              //    value={{label: firstLetterCapital(createRolePayload.status),value: createRolePayload.status}}
              className="col-md-12  mt-2"
              classNamePrefix="bg-gray"
              placeholder="Select Role Status" />
          </div>
        </div>
        <div className="form-group text-secondary pt-4">

          <table className="table table-strip mt-3 text-start">
            <thead>
              <tr>
                <th scope="col">Functionalities</th>
                <th scope="col">View</th>
                <th scope="col">Add / Edit</th>
              </tr>
            </thead>
            <tbody>
              {
                createRolePayload.roleFunctionalities && createRolePayload.roleFunctionalities.length > 0 && createRolePayload.roleFunctionalities.map((list, index) => (
                  <tr>
                    <td>{list.functionalityName}</td>
                    <td>
                      <div>
                        <span className="text-secondary pb-1"><Form.Check
                          checked={list.viewMode == 1}
                          inline
                          name="group1"
                          type='checkbox'
                          className="ms-2"
                          onChange={() => updateFunctionality(list.functionId, createRolePayload.roleFunctionalities[index].viewMode == 1 ? 0 : 1, modes.VIEW_MODE)}
                          disabled = {list.editMode === 1}
                        /></span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="text-secondary pb-1"><Form.Check
                          checked={list.editMode == 1}
                          inline
                          name="group1"
                          type='checkbox'
                          className="ms-2"
                          onChange={() => updateFunctionality(list.functionId, createRolePayload.roleFunctionalities[index].editMode == 1 ? 0 : 1, modes.EDIT_MODE)}
                        /></span>
                      </div>

                    </td>
                  </tr> 
                  //   <div>
                  //     <span className="text-secondary pb-1 ">Delete <Form.Check
                  //         inline
                  //         name="group1"
                  //         type='checkbox'
                  //         className="ms-2"
                  //         onChange={() => updateFunctionality(list.functionId, createRolePayload.roleFunctionalities[index].deleteMode == 1 ? 0 : 1, "deleteMode")}
                  //       /></span>
                  //   </div>
                  // </div>
                ))
              }
            </tbody>
          </table>
        </div>
        {editModeOn(functionalities.ROLE_MASTER_TAB) && (
        <div className="pt-5">
          <button
            className="btn btn-success"
            onClick={() => saveRoleData()}>Submit</button>
          <div className="btn btn-outline-success ms-4" onClick={() => { props.navigateToRoleMater(); setCreateRolePayload(defaultData); setOpenDropDown(false) }}>Cancel</div>
        </div>)}
      </div>
    </section>

  )
};

export default CreateRole;